import { combineReducers } from 'redux';

import { reducer as summaryReducer } from './summaryModule';

export default combineReducers({
	summary: summaryReducer,
});
